import { useMemo, useCallback } from "react";
import React from "react";
import { generatePath } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { ROUTES } from "../../../constant/common.constant";
import { TeamProject } from "./TeamProject/TeamProject";
import { ConvertToTeamDropZone } from "./ConvertToTeamDropZone";
import { useTeam } from "../../../context/Team/useTeam";
import ProjectService from "../../../service/ProjectService";

interface Props {
  canAddProject: boolean;
}

export const TeamProjects = (props: Props) => {
  const { teams, refetchTeams, refetchTeam } = useTeam();
  const { t } = useTranslation();

  const teamProjects = useMemo(() => {
    return teams?.map((team) => ({
      id: team.id,
      name: team.name,
      updatedAt: team.updated_at,
      projects: team.projects,
      teamUrl: generatePath(ROUTES.TEAM, {
        teamId: team.id,
      }),
      url: (projectId: string) =>
        generatePath(ROUTES.PROJECT, { projectId, teamId: team.id }),
    }));
  }, [teams]);

  const handleProjectConvert = useCallback(
    async (projectId: string) => {
      try {
        await ProjectService.turnIntoTeam(projectId);

        toast.success(t("project.converted_to_team_success"));

        await refetchTeams();
        await refetchTeam({ skipLoading: true });
      } catch (error) {
        console.error("Failed to convert project to team:", error);
        toast.error(t("project.converted_to_team_error"));
      }
    },
    [refetchTeams, t, refetchTeam]
  );

  return (
    <React.Fragment>
      <ConvertToTeamDropZone onProjectConvert={handleProjectConvert} />
      {teamProjects?.map((team, index) => (
        <React.Fragment key={team.id}>
          <TeamProject {...props} {...team} />
          {index < teamProjects.length - 1 && (
            <ConvertToTeamDropZone onProjectConvert={handleProjectConvert} />
          )}
        </React.Fragment>
      ))}
      <ConvertToTeamDropZone onProjectConvert={handleProjectConvert} />
    </React.Fragment>
  );
};
